module.exports = __webpack_public_path__ + "media/Audio15_m.45f876d9.wav";